import { createSlug } from "./slug";

/**
 * Generates a product URL with slug and product_id for SEO and immediate API fetching
 * @param {Object} product - Product object with id and name
 * @returns {string} - Product URL with slug and product_id
 */
export function getProductLink(product) {
  if (!product || !product.id) {
    return "/product";
  }

  const productId = String(product.id);
  const productName = product.name || product.title || "";

  // If we have a name, include slug for SEO
  if (productName) {
    const slug = createSlug(productName);
    return `/product/${productId}?product=${encodeURIComponent(slug)}&product_id=${productId}`;
  }

  // Fallback to just product_id
  return `/product/${productId}?product_id=${productId}`;
}
